import React, { ReactNode } from 'react';

interface OutlineButtonProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  id?: string;
  "data-testid"?: string;
}

const OutlineButton: React.FC<OutlineButtonProps> = ({ onClick, children, id, "data-testid": dataTestId }) => {
  return (
    <button
      id={id}
      data-testid={dataTestId}
      onClick={onClick}
      className={`tw-w-max tw-px-[16px] tw-py-[7px] tw-border-[1px] tw-border-accent tw-text-accent hover:tw-bg-accent-bold hover:tw-text-ink-inverse tw-rounded-[4px] tw-transition tw-duration-300 tw-ease-in-out focus:tw-outline-none focus:tw-ring-none focus:tw-border-accent-hover`}>
      {children}
    </button>

  );
};

export default OutlineButton;
